import {
  RELATED_PARTY_RELATIONSHIP,
  RELATED_PARTY_TYPES,
} from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPropertyRecordType } = loanFormModel.formField;

class IsPropertyOwnerAnotherBusiness implements Rule {
  get dependsOn(): string[] {
    return [`principals[${this.index}].${systemPropertyRecordType.name}`];
  }

  private index: number;

  private getLandLord(data: Partial<ApplicationFormValues>) {
    return data.principals?.find(
      (principal) =>
        principal.relationship === RELATED_PARTY_RELATIONSHIP.LANDLORD
    );
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const landLord = this.getLandLord(application);
    return (
      landLord?.[systemPropertyRecordType.name] === RELATED_PARTY_TYPES.ENTITY
    );
  }
}

export default new IsPropertyOwnerAnotherBusiness();
